<template>
  <svg
    class="custom-icon"
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      stroke="rgb(var(--v-theme-primary))"
      fill="#ffffff"
      stroke-width="1"
      x="1.855426"
      y="0.855426"
      width="6.289148"
      height="6.289148"
      rx="2"
    />
    <path
      stroke="null"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="m6.907813,2.440647c0.177813,0.142433 0.206437,0.402022 0.064027,0.579813l-1.982684,2.474883c-0.071926,0.089781 -0.178075,0.145452 -0.292825,0.153561c-0.114758,0.008116 -0.227677,-0.032062 -0.311524,-0.110827l-1.317163,-1.237442c-0.166035,-0.15599 -0.174181,-0.417022 -0.018198,-0.583057c0.155982,-0.166035 0.417022,-0.174181 0.583049,-0.018198l0.99188,0.931844l1.703625,-2.126559c0.142433,-0.177791 0.402022,-0.206452 0.579813,-0.064019z"
      fill="rgb(var(--v-theme-primary))"
    />
  </svg>
</template>
